import { render, staticRenderFns } from "./ypcxListConfigAction.vue?vue&type=template&id=05fc9256"
import script from "./ypcxListConfigAction.vue?vue&type=script&lang=js"
export * from "./ypcxListConfigAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports